
  export default {
    data() {
      return {
        playing: false
      }
    },
    props: {
      blok: {
        type: Object,
        default: () => {}
      }
    }
  }
